import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white flex" }
const _hoisted_2 = { class: "flex-1 flex flex-col justify-center py-12 px-4 w-1/2 sm:px-6 lg:px-20 xl:px-24" }
const _hoisted_3 = { class: "mx-auto w-full max-w-md" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-3xl font-extrabold text-gray-900" }, " Register ", -1)
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = {
  key: 0,
  class: "rounded-md bg-red-50 p-6 mb-6"
}
const _hoisted_7 = { class: "text-red-700" }
const _hoisted_8 = ["for"]
const _hoisted_9 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_10 = ["onUpdate:modelValue", "type", "readonly", "onChange", "onInput", "onBlur"]
const _hoisted_11 = {
  key: 0,
  class: "block -mt-2 text-red-500 mb-2"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "p-6 text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block relative w-1/2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute inset-0 h-full w-full object-cover",
    src: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=10",
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            ($setup.registerError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString($setup.registerError), 1)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.schema.fields, (field, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("label", {
                  class: "block w-full mb-2",
                  for: field.name
                }, [
                  _createTextVNode(_toDisplayString(field.label) + " ", 1),
                  (field.required)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " * "))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_8),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => (($setup.formValues[field.name]) = $event),
                  class: _normalizeClass(["block w-full mb-4 px-4 py-2 rounded border", [field.readonly ? 'bg-gray-100' : '', $setup.formErrors[field.name] ? 'border-red-500' : '']]),
                  type: field.type,
                  readonly: field.readonly,
                  onChange: ($event: any) => ($setup.validateField(field.name)),
                  onInput: ($event: any) => ($setup.validateField(field.name)),
                  onBlur: ($event: any) => ($setup.validateField(field.name))
                }, null, 42, _hoisted_10), [
                  [_vModelDynamic, $setup.formValues[field.name]]
                ]),
                ($setup.formErrors[field.name])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.formErrors[field.name]), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("button", {
              type: "submit",
              class: _normalizeClass(["bg-brand text-white px-4 py-3 mt-4 rounded w-full", !$setup.formValid ? 'opacity-25' : '']),
              disabled: !$setup.formValid,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.registerUser && $setup.registerUser(...args)))
            }, _toDisplayString($setup.schema.submitText), 11, _hoisted_12),
            _createElementVNode("p", _hoisted_13, [
              _createTextVNode(" Have an account? "),
              _createVNode(_component_router_link, {
                to: "/sign-in",
                class: "text-brand font-medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Sign In ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _hoisted_14
  ]))
}